import React from 'react';

const Bullets = ({ content }) => {
	if (content?.length === 0) {
		return null;
	}
	return (
		<ul className="product-card__textLink--customCats xl:border-0 xl:border-t xl:border-solid border-gray-30 flex flex-col xl:flex-row xl:justify-between mt-2 text-body-xs z-20">
			{content
				.filter((item) => item.replace(/\s/g, ''))
				.map((item, index) => {
					const isLink = item.includes('data-video');
					return (
						<li
							className="flex items-start list-none xl:pt-2 pr-2 xl:m-2"
							key={index}
							data-tag-name="bullet-video-clicked">
							{isLink ? (
								<>
									<div className="flex-shrink-0 bg-gray-80 rounded-lg h-1 w-1 mt-2" />
									<button
										type="button"
										className="p-0 bg-transparent text-left text-body-xs pl-2"
										onClick={null}
										dangerouslySetInnerHTML={{ __html: item }}
									/>
								</>
							) : (
								<>
									<div className="flex-shrink-0 bg-gray-80 rounded-lg h-1 w-1 mt-2" />
									<span
										className="pl-2"
										dangerouslySetInnerHTML={{ __html: item }}
									/>
								</>
							)}
						</li>
					);
				})}
		</ul>
	);
};
export default Bullets;
